import { useTranslation } from 'react-i18next'

import { ICON_HEIGHT_16, IconWithTooltip } from '../../../Icon'
import Text from '../../../Text'

import * as styles from './ProfileContactsWidgetLabel.module.css'

import InfoIcon from '../../../../icons/info.svg'

function ProfileContactsWidgetLabel({
  className,
  infoTooltipKey,
  isSecondary,
  label,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.wrapper}>
      <Text className={className} isSecondary={isSecondary}>
        {label}
      </Text>
      {infoTooltipKey ? (
        <IconWithTooltip
          Icon={InfoIcon}
          size={ICON_HEIGHT_16}
          tooltip={t(infoTooltipKey)}
        />
      ) : null}
    </div>
  )
}

export default ProfileContactsWidgetLabel
